import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";

import { _fetchDownloads } from "../services/clientdownloads";

const initialState = {
  downloads: [],
  isLoading: false,
  pagination: {
    currentPage: 1,
    totalPage: 1,
    isLastPage: false,
  },
  filters: {
    search: "",
  },
  sorting: {
    sortByColumn: "",
    sortByOrder: "",
  },
};

export const fetchDownloads = createAsyncThunk(
  "clientDownloads/fetchDownloads",
  async (data, { dispatch, getState }) => {
    const {
      clientDownloads: { pagination, filters, sorting },
    } = getState();

    if (_.isEmpty(data)) {
      data = {
        ...filters,
      };
    }
    if (pagination.isLastPage) {
      return dispatch(setLoading(false));
    }

    const _data = {
      ...data,
      page: pagination.currentPage,
      ...sorting,
    };

    const response = _fetchDownloads(_data);
    response
      .then((res) => {
        const {
          data: { download_report_list: data, message, meta },
        } = res;
        const { currentPage, lastPage, isLastPage, total: totalCount } = meta;
        dispatch(
          updatePagination({
            currentPage: currentPage + 1,
            totalPage: lastPage,
            isLastPage: isLastPage,
          }),
        );
        let prevList =
          currentPage === 1 ? [] : _.uniq(getState().clientDownloads.downloads);
        let firstid = data.length > 0 ? data[0].id : null;
        if (
          prevList.length > 0 &&
          prevList.find((item) => item.id === firstid) !== undefined
        ) {
          //
        } else {
          dispatch(updateDownloads([...prevList, ...data]));
        }
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        setTimeout(() => {
          dispatch(setLoading(false));
        }, 10);
      });
  },
);

const clientDownloadsSlice = createSlice({
  name: "clientDownloads",
  initialState,
  reducers: {
    updateDownloads: (state, action) => {
      state.downloads = action.payload;
    },
    updatePagination: (state, action) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      };
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    updateSorting: (state, action) => {
      state.sorting = action.payload;
    },
    updateFilters: (state, action) => {
      if (_.isEmpty(action.payload)) {
        state.filters = {
          search: state.filters.search,
          ...initialState.filters,
        };
        return;
      } else {
        if (action.payload.reset) {
          state.filters = initialState.filters;
        } else {
          state.filters = { ...state.filters, ...action.payload };
        }
      }
    },
  },
});

export const {
  updateDownloads,
  updatePagination,
  setLoading,
  updateSorting,
  updateFilters,
} = clientDownloadsSlice.actions;

export default clientDownloadsSlice.reducer;
